<div *ngIf="this.loadingAuto" class="loader-container">
    <div class="circle button" id="button-0"></div>
    <p>Cargando</p>
</div>
